import { PointerWithRecord } from "libs/schema";
import { IListOnEntryActionEvent, IListRef } from "~/components/list";
import { ClientEnvironment } from "~/environment/ClientEnvironment";
import { isModKeyActive } from "~/environment/command.service";
import { UnreachableCaseError } from "libs/errors";
import { IThreadViewContext } from "../thread/context";
import { useMemo } from "react";

export type TSentEntry = PointerWithRecord<"message">;

/* -----------------------------------------------------------------------------------------------*/

export async function onSentEntrySelect(
  environment: Pick<ClientEnvironment, "router">,
  props: {
    event: IListOnEntryActionEvent<TSentEntry>;
  },
) {
  const { event } = props;

  switch (event.entry.table) {
    case "message": {
      return environment.router.navigate(`/sent/threads/${event.entry.record.thread_id}`, {
        openInNewTab: isModKeyActive(event.event),
      });
    }
    default: {
      throw new UnreachableCaseError(event.entry.table);
    }
  }
}

/* -----------------------------------------------------------------------------------------------*/

export function useSentViewThreadContext(props: { listRef: React.RefObject<IListRef<TSentEntry>> }) {
  const { listRef } = props;

  return useMemo((): IThreadViewContext => {
    return { threadList: { type: "sent", ref: listRef } };
  }, [listRef]);
}

/* -----------------------------------------------------------------------------------------------*/
